module.exports = __webpack_public_path__ + "img/dump_parked.32316a87.svg";